var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowOpenUp
    ? _c("div", [
        _c("div", { staticClass: "zhezhao" }),
        _vm._v(" "),
        _c("div", { staticClass: "open-up-box" }, [
          _c("div", [
            _c("img", {
              staticClass: "tc-on shut",
              attrs: { src: "/static/img/qiye/chahao.png", alt: "" },
              on: { click: _vm.closeModal }
            })
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "box-content" }, [
            _vm.unauthorized
              ? _c("div", { staticClass: "reg-mess" }, [
                  _c("ul", { staticClass: "cloud-kind" }, [
                    _c(
                      "li",
                      {
                        class: _vm.appId == "trade-app" ? "kind-active" : "",
                        on: {
                          click: function($event) {
                            _vm.appId = "trade-app"
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: "/static/img/trade.svg", alt: "" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("贸易云")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: _vm.appId == "make-app" ? "kind-active" : "",
                        on: {
                          click: function($event) {
                            _vm.appId = "make-app"
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: "/static/img/make.svg", alt: "" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("制造云")])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { clear: "both" } })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nowcompany" }, [
                    _c("p", [
                      _vm._v("\n            当前企业：\n            "),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.unauthorized.name))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-openup" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("p", { staticClass: "aa" }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-right": "34px",
                          "font-size": "14px"
                        }
                      },
                      [_vm._v("您尚未开通")]
                    ),
                    _vm._v(" "),
                    _vm.inviteCode
                      ? _c("label", { attrs: { for: "company" } }, [
                          _vm._v("专属顾问")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.inviteCode
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.partner.name,
                              expression: "partner.name"
                            }
                          ],
                          attrs: {
                            type: "text",
                            id: "inviteCode",
                            readonly: "readonly"
                          },
                          domProps: { value: _vm.partner.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.partner, "name", $event.target.value)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "open-up-btn",
                        on: {
                          click: function($event) {
                            _vm.applyApp()
                          }
                        }
                      },
                      [_c("span", [_vm._v("立即开通")])]
                    ),
                    _vm._v(" "),
                    _c("p")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.session && _vm.session.account.companies.length
              ? _c("div", { staticClass: "has-been-openup" }, [
                  _c("span", [_vm._v("您有以下关联已开通企业：")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.session.account.companies, function(item, i) {
                      return _c("li", { key: i }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                _vm.redirectApp(item)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ])
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "register" }, [
              _c("span", { on: { click: _vm.checkRegister } }, [
                _vm._v("注册新企业")
              ])
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-title", staticStyle: { background: "#ffffff" } },
      [
        _c(
          "p",
          { staticStyle: { position: "relative", padding: "18px 25px" } },
          [
            _c("img", {
              staticStyle: { width: "150px" },
              attrs: { src: "/static/img/log_b1.png", alt: "" }
            })
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "notice" }, [
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      _vm._v("开通即是表示同意\n            "),
      _c(
        "a",
        {
          attrs: {
            href: "https://saas-help.usoftchina.com/doc/base/service_protocol",
            target: "_blank"
          }
        },
        [_vm._v("《华商云服平台服务条款》")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79068c9d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79068c9d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/openupbox.vue
// module id = null
// module chunks = 